import * as z from "zod";

// Builds a Shopify OAuth URL that links the shop to the CURRENT team on
// callback (signed link token in state) instead of creating a new team.
export const getShopifyLinkInstallUrl = {
  name: "getShopifyLinkInstallUrl" as const,
  input: z.object({
    shop: z.string().max(255),
    nextPath: z.string().max(1024),
  }),
  output: z.object({ authorizationUrl: z.string() }),
};
